import { DecimalPipe } from '@angular/common';
import { Directive, ElementRef, HostListener, OnInit, Renderer2 } from '@angular/core';

@Directive({
    selector: '[currencyFormatter]',
    standalone: false
})
export class CurrencyFormatterDirective implements OnInit {
  currencyChars = new RegExp('[\.,]', 'g'); // we're going to remove commas and dots

  constructor(
    public el: ElementRef,
    public renderer: Renderer2,
    private readonly decimalPipe: DecimalPipe){

    }

  ngOnInit() {
    this.format(this.el.nativeElement.value); // format any initial values
  }

  @HostListener('input', ['$event.target.value']) onInput(e: string) {
    this.format(e);
  };

  @HostListener('paste', ['$event']) onPaste(event: ClipboardEvent) {
    event.preventDefault();
    this.format(event.clipboardData.getData('text/plain'));
  }

  format(val: string) {
    //test for non-number characters and replace/remove them
    if (val !== '-') {
      const numberFormat = parseInt(String(val).replace(this.currencyChars, ''));

      //format the number (add commas)
      const usd = this.decimalPipe.transform(numberFormat, '1.0-0');

      //replace the input value with formatted numbers
      this.renderer.setProperty(this.el.nativeElement, 'value', usd);
    }
    else {
      this.renderer.setProperty(this.el.nativeElement, 'value', val);
    }

  }

}
